import React from 'react';
import './TarjetaSinopsis.css';
import TarjetaInfoLibro from './TarjetaInfoLibro';

const TarjetaSinopsis = (props) => {


    return (
        <div className="contenedor-tarjeta-sinopsis">
            <div className="tarjeta-sinopsis seleccionable"
                onMouseEnter={() => props.mostrarTarjetaInfo(props.indice)}
                onMouseLeave={() => props.ocultarTarjetaInfo(props.indice)}>

                <h4>{props.datos.titulo}</h4>
                <div>
                    <p>
                        {props.datos.cuerpo}
                    </p>
                </div>
            </div>{
                props.indiceSeleccionado == props.indice ?
                    <TarjetaInfoLibro info={props.datos.info}/>
                    :
                    null
            }
        </div>
    )
}


export default TarjetaSinopsis;